import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { GenerateEmailExampleQueryVariables } from '@/gql/graphql';
import type { EmailExample } from '@/models/email';

export const generateEmailExample = async ({
  emailName,
  language,
  countryCode,
}: GenerateEmailExampleQueryVariables): Promise<EmailExample> => {
  const response = await queryExecute({
    query: graphql(`
      query GenerateEmailExample($emailName: String!, $countryCode: String, $language: String) {
        generateEmailExample(emailName: $emailName, countryCode: $countryCode, language: $language) {
          subject
          content
        }
      }
    `),
    variables: {
      emailName,
      language,
      countryCode,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.generateEmailExample;
};
